// extracted by mini-css-extract-plugin
module.exports = {"Container":"BuyerSelection_Container__l3cYv","Title":"BuyerSelection_Title__CB8yV","SubMenu":"BuyerSelection_SubMenu__eluXh"};